<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <SeleccionDocumentos></SeleccionDocumentos>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import SeleccionDocumentos from '../components/SeleccionDocumentos.vue';
export default {
    name: 'DocumentView',
    components: {
        ColumnaIzquierda,
        SeleccionDocumentos,
    }
}
</script>